import CustomTable from "@/components/CustomTable";
import { getMerchantTeams } from "@/services/Settings.service";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useState } from "react";
import { columnsT } from "./columns";
import { Button } from "@/components/ui/button";
import { IoFunnelOutline } from "react-icons/io5";
import { Input } from "@/components/ui/input";
import { ChevronLeft, UserPlus } from "lucide-react";
import Invite from "./common/Invite";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link } from "react-router";
import { HiOutlineSlash } from "react-icons/hi2";

const TeamManagement = () => {
  const [filter, setFilter] = useState({
    page: 1,
    search: "",
  });
  const { data, isLoading, isFetching, refetch, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: ["teams"],
      queryFn: async ({ pageParam = filter.page }) =>
        await getMerchantTeams(pageParam, filter),
      getNextPageParam: (lastPage, pages) => {
        if (lastPage.length === 0) return undefined;
        return pages.length + 1;
      },
      placeholderData: keepPreviousData,
    });

  const dataArr = data?.pages?.map((page) => page.data.data.data).flat();
  const meta = data?.pages?.map((page) => page.data.data.meta).flat()[0];

  const handlePageChange = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <div className="flex flex-col gap-8 p-6">
      <div>
        <Breadcrumb>
          <BreadcrumbList className="gap-2">
            <BreadcrumbItem>
              <Link
                to="/dashboard/settings"
                className="flex items-center gap-1 text-sm text-primary0"
              >
                <ChevronLeft className="w-3 h-3" />
                Settings
              </Link>
            </BreadcrumbItem>
            <BreadcrumbSeparator>
              <HiOutlineSlash />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbLink className="flex items-center gap-1 text-sm text-gray-60">
                Teams
              </BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-4 py-4">
        <Input
          placeholder="Search for users by name, email or user ID"
          value={(filter?.search as string) ?? ""}
          onChange={(event) =>
            setFilter({ ...filter, search: event.target.value })
          }
          className="max-w-sm bg-input-border"
        />
        <div className="flex flex-wrap gap-4 ml-auto">
          <Button variant="outline" className="border-off-white text-primary0">
            <IoFunnelOutline />
            Filter by
          </Button>
          <Invite />
        </div>
      </div>
      <CustomTable
        data={dataArr ?? []}
        meta={meta}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        columns={columnsT}
      />
    </div>
  );
};

export default TeamManagement;
